import * as React from "react";
import type { SVGProps } from "react";
const StartPointDiamondIcon = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" fill="none" style={{
  userSelect: "none",
  flexShrink: 0
}} {...props}><path fill="currentColor" fillRule="evenodd" d="M5.47 8.47a.75.75 0 0 1 1.06 0l2.78 2.78H21a.75.75 0 0 1 0 1.5H9.31l-2.78 2.78a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 0 1 0-1.06z" clipRule="evenodd" /></svg>;
export default StartPointDiamondIcon;